module.exports = __webpack_public_path__ + "static/media/play-store.e017762f.svg";